module.exports = __webpack_public_path__ + "img/list-inveeted.f4dcf8a2.png";